import CapitalizationUtil from "../../utils/CapitalizationUtil.ts";
import { GenericResponseType } from "../../types/response.ts";
import { COMMON_API_URL } from "../../constants/urls";

const fetchData = async (
  jwt: string,
  callfunc: string,
  additionalParams?: any
): Promise<string | object> => {
  const response = await fetch(`${COMMON_API_URL}/${callfunc}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
    body: JSON.stringify({ ...additionalParams }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data: GenericResponseType =
    CapitalizationUtil.convertTopLevelKeysToCamelCase(await response.json());

  if (data.error) {
    throw new Error(data.error);
  }

  return data.result.offData ? data.result.offData : data.result;
};

const OfficeService = {
  getOffTree: (jwt: string) => fetchData(jwt, "getOffTree"),
  getOfficeById: (jwt: string, officeId: string) =>
    fetchData(jwt, "getOfficeData", { div: officeId }),
  saveOffice: (jwt: string, offData: object) =>
    fetchData(jwt, "office_write", { offData }),
  getOfficeStatistics: (jwt: string) => fetchData(jwt, "getBaseResults"),
  getOfficeChartStatistic: (jwt: string) =>
    fetchData(jwt, "getBaseResultsSeries"),
};

export default OfficeService;
